<template>
  <div class="about">
    <PageTitle
      title="Developed By"
      subtitle="Bankole Esan (aka <a href='https://bankole2000.github.io/webpieces' target='_blank'>@CodingInNeon</a>)"
    />
  </div>
</template>
<script>
import PageTitle from "../components/blocks/PageTitle";
export default {
  components: {
    PageTitle,
  },
};
</script>
